var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoGrafico01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    d: "M33.8,34.6H2.2c-1,0-1.8-0.8-1.8-1.8V17.1c0-1.9,1.6-3.5,3.5-3.5h7V4.9c0-1.9,1.6-3.5,3.5-3.5h7 c1.9,0,3.5,1.6,3.5,3.5v5.3h7c1.9,0,3.5,1.6,3.5,3.5v19.3C35.5,33.9,34.7,34.6,33.8,34.6z M25,13.6v17.5h7V13.6H25z M14.5,4.9v26.3 h7V4.9H14.5z M4,17.1v14h7v-14H4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrafico01);
export default __webpack_public_path__ + "static/media/ico-grafico-01.7af42c97c21c54180ccb104d2aef690a.svg";
export { ForwardRef as ReactComponent };